<template>
  <div>
    <div v-for="(item, index) in list" :key="index + 'listIndex'">
      <div class="ranking-list-item" :class="{ me: isMe }">
        <div class="ranking-num" v-if="isMe">
          <p>我</p>
          <p class="color-red">{{ rank(item) }}</p>
        </div>
        <div v-else class="ranking-num">
          <p v-if="rank(item) > 3">{{ rank(item) }}</p>
          <div v-else>
            <van-image class="img" round :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/top${rank(item)}.png`" alt="" />
          </div>
          <!-- <img v-else :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/top${rank(item)}.png`" alt=""> -->
        </div>
        <div class="ranking-name">
          <van-image class="img" round :src="item?.avatar" error-icon="" />
          <div>
            <div class="flex flex-y-center">
              <span>{{ item?.empName }}</span>
              <div v-if="currentJobTab == 3" :class="['storeLogo', item.tenantCode == 25002 ? 'jc-25002' : 'jc-25001']">{{ item.tenantJcName }}</div>
            </div>
            <div class="ellipsis">{{ item?.storeName }}</div>
          </div>
        </div>
        <div class="ranking-order">{{ order(item) }}</div>
        <div class="ranking-bonus">{{ item?.awardName || '-' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RankingItem',
    props: {
      list: {
        type: Array,
        default: () => []
      },
      dataInfo: {
        type: Object,
        default: function () {
          return {};
        },
      },
      isMe: {
        type: Boolean,
        default: false
      },
      index: {
        type: Number,
        default: 0
      },
      currentJobTab: {
        type: String | Number,
        default: '1'
      },
      currentGroupTab: {
        type: String,
        default: '第一组'
      }
    },
    computed: {
      rank() {
        return function (item) {
          return item?.rnkNum
        }
      },
      order() {
        return function (item) {

          if (this.currentJobTab == 3) {
            return item?.salesNum
          }
          return item?.daChengRatio + "%"

        }
      },
    },
    data() {
      return {

      }
    },
    methods: {
    }
  }
</script>

<style lang='less' scoped>
  .ranking-list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // margin: 10px 0;
    padding: 30px 40px;
    border-bottom: 2px solid #eeeeee;

    &.me {
      padding: 20px;
      margin-top: 30px;
      background-color: #FDE3D7;
      border-radius: 12px;
      border: none;

      .ranking-num {
        text-align: center;

      }
    }

    &.title {
      padding-bottom: 0;
      border: none;
      color: #999999;
    }

    // &:nth-last-child(1) {
    //     border: none;
    // }

    .ranking-num {
      width: 60px;
      margin-right: 30px;

      .color-red {
        color: #AB080B;
      }

      .img {
        width: 50px;
        height: 60px;
      }

      p {
        margin: 0;
        text-align: center;
      }
    }

    .ranking-name {
      display: flex;
      align-items: center;
      width: 260px;

      div {
        width: 100%;
      }

      >.img {
        width: 60px;
        height: 60px;
        min-width: 60px;
        margin-right: 10px;
      }

    }

    .ranking-order {
      width: 160px;
      text-align: center;
    }

    .ranking-bonus {
      width: 180px;
      text-align: center;
    }

    .flagImg {
      width: 65px;
      height: 54px;
    }

    .storeLogo {
      width: 38px !important;
      height: 27px;
      background: #A58B5B;
      border-radius: 13px 13px 13px 13px;
      font-size: 20px;
      color: #FFFFFF;
      text-align: center;
      margin-left: 10px;
    }

    .storeLogo.jc-25001 {
      background: #EB9E01;
    }

    .storeLogo.jc-25002 {
      background: #3365D2;

    }
  }
</style>
